import { countries } from '@adjust/dashboard-core/lib/constants/countries';

export const countryOptions = countries.map(country => ({ value: country.code, label: country.name }));
